export type Theme = 'tide' | 'arctic';
/** Motion stagger steps from the brand kit (ms): rail 40, list 70, tiles 80, stats 90, agent lines 300. */
export const STAGGER = { rail: 40, list: 70, tiles: 80, stats: 90, agent: 300 } as const;
export const delay = (i: number, step: number): Record<string, string> => ({ ['--d']: `${i * step}ms` });
export * from './components.tsx';
export * from './charts.tsx';
